import { DtoBase } from "../../DtoBase";

export enum DirectoryResultCode {
	None,
	Succeeded,
	Failed,
	Redirect,
}


export abstract class DirectoryResultDto extends DtoBase {

	public Code: DirectoryResultCode;
	public Message: string;

	constructor(code: DirectoryResultCode = DirectoryResultCode.None) {
		super();

		this.Code = code;
		this.Message = "";
	}

	public get HasCode(): boolean {
		return (this.Code !== DirectoryResultCode.None);
	}

	public get HasMessage(): boolean {
		return !!this.Message;
	}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		super.Write(obj, context);

		if (this.HasCode) {
			obj.code = DirectoryResultCode[this.Code];
		}

		if (this.HasMessage) {
			obj.message = this.Message;
		}
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		super.Read(obj, context);

		if (obj.code !== undefined) {
			this.Code = DirectoryResultCode[<string>obj.code];
		}

		if (obj.message !== undefined) {
			this.Message = obj.message;
		}
	}

}